import { sendDwh } from 'reactApp/utils/ga';

export const FamilySpaceToEachBalloonOnShow = () => {
    sendDwh({
        eventCategory: 'balloon',
        action: 'show',
        dwhData: {
            name: 'mnzfam_separate_quota_promo',
        },
        dwh_enabled: true,
    });
};
